'use client'

import { ChevronRightIcon } from '@repo/ui/ChevronRightIcon'
import MUIButtonIcon from '@mui/material/IconButton'
import { useTheme } from '@mui/material/styles'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'
import { useEffect, useState } from 'react'
import { useWindowSize } from '@uidotdev/usehooks'

export const NavigationSidebarModeSwitcher = () => {
  const theme = useTheme()
  const darkColor = theme?.palette?.support?.navy || 'black'
  const borderColor = theme?.palette?.background?.slate100 || 'black'
  const { setSidebarMode, sidebarMode, sidebarBreakpoint } = useGlobalSettingsStore()
  const [isExpanded, setIsExpanded] = useState(sidebarMode === 'expanded')
  const { width: windowWidth } = useWindowSize()

  useEffect(() => {
    setIsExpanded(sidebarMode === 'expanded')
  }, [sidebarMode])

  return (
    <MUIButtonIcon
      data-testid="NavigationSidebarModeSwitcher"
      aria-label="sidebar-mode"
      onClick={() => {
        setSidebarMode(isExpanded ? 'collapsed' : 'expanded')
      }}
      className={isExpanded ? 'expanded' : ''}
      sx={{
        backgroundColor: 'white',
        width: '22px',
        height: '22px',
        position: 'fixed',
        top: '70px',
        border: `1px solid ${borderColor}`,
        transform: `translate(-50%, -50%) rotate(0deg)`,
        transition: 'all 250ms',
        zIndex: 12,
        visibility: windowWidth < sidebarBreakpoint ? 'hidden' : 'visible',
        '&:hover': {
          backgroundColor: 'white'
        },
        '&.expanded': {
          transform: `translate(-50%, -50%) rotate(-180deg)`
        }
      }}
    >
      <ChevronRightIcon sx={{ color: darkColor, width: '22px', height: '22px' }} />
    </MUIButtonIcon>
  )
}
